import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import SafetyGuidePage from "../pages/article-safety/page";
import ComparisonGuidePage from "../pages/article-comparison/page";
import ShoesGuidePage from "../pages/article-shoes/page";
import HoodiesGuidePage from "../pages/article-hoodies/page";
import AccessoriesGuidePage from "../pages/article-accessories/page";
import BagsGuidePage from "../pages/article-bags/page";
import JacketsGuidePage from "../pages/article-jackets/page";
import TshirtsGuidePage from "../pages/article-tshirts/page";
import PerfumesGuidePage from "../pages/article-perfumes/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-beginner-guide",
    element: <ArticlePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-safety-guide",
    element: <SafetyGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-comparison-guide",
    element: <ComparisonGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-shoes-guide",
    element: <ShoesGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-hoodies-guide",
    element: <HoodiesGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-accessories-guide",
    element: <AccessoriesGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-bags-guide",
    element: <BagsGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-jackets-guide",
    element: <JacketsGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-tshirts-guide",
    element: <TshirtsGuidePage />,
  },
  {
    path: "/vigorbuy-spreadsheet-perfumes-guide",
    element: <PerfumesGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;